// $FlowFixMe
/* eslint-disable flowtype/no-types-missing-file-annotation */

import * as React from 'react';
import { css } from 'glamor';
import { withNamespaces } from 'react-i18next';

type Props = {
  t: (string, string) => string
}

export const Header = ({ t }: Props) => (
  <div className={`modal-header ${styles}`}>
    <h4>
      {t('App.LoginModal.SignIn', 'Sign In to fuboTV')}
    </h4>
  </div>
);

export default withNamespaces()(Header);

const styles = css({
  fontWeight: 'bold',
  fontSize: '18px',
  color: 'rgb(43, 45, 46)',
  textAlign: 'left',
  lineHeight: '27px',
  margin: 0,
});
